export default __webpack_public_path__ + "static/Muji Herliyanti-9cebc4e7a281cbd2109d8056b38caab2.webp";